import { render, staticRenderFns } from "./ShopCar.vue?vue&type=template&id=24ec9998&scoped=true"
import script from "./ShopCar.vue?vue&type=script&lang=js"
export * from "./ShopCar.vue?vue&type=script&lang=js"
import style0 from "./ShopCar.vue?vue&type=style&index=0&id=24ec9998&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ec9998",
  null
  
)

export default component.exports